import type { SamanDoctorAvailabilityStatus } from '@/common/apis/services/booking/samanDoctorAvailabilityStatus';
import { CENTERS } from '@/common/types/centers';

/** Iran: +03:30 all year (no daylight saving since 2022). */
const TEHRAN_OFFSET_MS = 210 * 60_000;

/**
 * Tomorrow (Tehran) at the doctor's own release clock, or tomorrow 07:45 when the doctor has none announced —
 * in Tehran time whatever the device's time zone (shifted by the fixed offset, then read with UTC getters).
 */
export const nextReleaseAt = (realReleaseAt?: string | null, now = new Date()) => {
  const at = new Date(now.getTime() + TEHRAN_OFFSET_MS);
  at.setUTCDate(at.getUTCDate() + 1);
  const realMs = realReleaseAt ? new Date(realReleaseAt).getTime() : NaN;
  const real = Number.isNaN(realMs) ? null : new Date(realMs + TEHRAN_OFFSET_MS);
  // a real clock only when the doctor announced one; a bare date (00:00) or nothing → 07:45
  const hasClock = real && (real.getUTCHours() !== 0 || real.getUTCMinutes() !== 0);
  if (hasClock) at.setUTCHours(real.getUTCHours(), real.getUTCMinutes(), 0, 0);
  else at.setUTCHours(7, 45, 0, 0);
  return new Date(at.getTime() - TEHRAN_OFFSET_MS).toISOString();
};

/**
 * Saman answer of a doctor whose capacity is full until the next release — what the rollout profile shows
 * to its owner: the red «زمان نوبت دهی پزشک به پایان رسیده است.» card instead of the booking buttons.
 */
export const buildDabbehFullSaman = (centers: Array<{ id: string }>, realReleaseAt?: string | null): SamanDoctorAvailabilityStatus => {
  const releaseAt = nextReleaseAt(realReleaseAt);
  const full = { booking_available: false, nearest_time_slot: null, nearest_available_time: releaseAt };
  const closed = { booking_available: false, nearest_time_slot: null, nearest_available_time: null };
  return {
    in_person_availability: full,
    online_visit_availability: closed,
    centers: (centers ?? []).map(center => ({
      id: String(center.id),
      availability_status: String(center.id) === CENTERS.CONSULT ? closed : full,
    })),
  };
};
